
import { defineComponent } from 'vue'

import { IdfImage } from '@invivodf/ui-kit'
import PHeading from '@/retail/application/presenters/PHeading/PHeading.vue'

import { IProduct } from '../../../../domain/IProduct'
import { IProductFeatureListItem } from '../../../../domain/IProductFeatureListItem'

import PProductFeatureList from './PProductFeatureList.vue'

export default defineComponent({
  name: 'PProductInfo',
  components: {
    PHeading,
    IdfImage,
    PProductFeatureList,
  },
  props: {
    brand: {
      type: String,
      default: null,
    },
    category: {
      type: String,
      default: null,
    },
    createdDate: {
      type: String,
      default: null,
    },
    deliveryTime: {
      type: String,
      default: null,
    },
    ean: {
      type: String,
      default: null,
    },
    image: {
      type: String,
      default: null,
    },
    mixed: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: null,
    },
    nomenclature: {
      type: String,
      default: null,
    },
    packaging: {
      type: String,
      default: null,
    },
    promotions: {
      type: Array,
      default: null,
    },
    sku: {
      type: String,
      default: null,
    },
    subcategory: {
      type: String,
      default: null,
    },
    supplier: {
      type: String,
      default: null,
    },
  },
  computed: {
    descriptionFeatures(): IProductFeatureListItem[] {
      return this.formatFeaturesGroup(['sku', 'createdDate'])
    },
    originFeatures(): IProductFeatureListItem[] {
      return this.formatFeaturesGroup(['ean', 'supplier', 'brand', 'category', 'subcategory'])
    },
    shippingFeatures(): IProductFeatureListItem[] {
      return this.formatFeaturesGroup(['packaging', 'nomenclature', 'deliveryTime', 'mixed', 'promotions'])
    },
  },
  methods: {
    formatFeatureValue(key: keyof IProduct): string | undefined {
      const keysWithDateAsValue = ['createdDate']
      const value = this[key]
      switch (true) {
        case typeof value === 'undefined' || value === null:
          return undefined
        case keysWithDateAsValue.includes(key):
          return new Intl.DateTimeFormat('en-US', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(
            new Date(value),
          )
        case typeof value === 'boolean':
          /* @todo: Check why there is a TS issue when doing type augmentation on $staticBooleanLabel. Set temporary any. */
          return (this as any).$staticBooleanLabel(value)
        case typeof value === 'object' && Array.isArray(value):
          /* @todo: Check why there is a TS issue when doing type augmentation on $staticBooleanLabel. Set temporary any. */
          return (this as any).$staticBooleanLabel(Boolean(value.length))
        default:
          return value
      }
    },
    formatFeaturesGroup(keys: Array<keyof IProduct> = []): IProductFeatureListItem[] {
      const output: Array<{ label: string; value: any }> = keys
        .map((key) => {
          /* @todo: Check why there is a TS issue when doing type augmentation on $staticLabel. Set temporary any. */
          const label = (this as any).$staticLabel(`productFeatures.${key}`)
          const value: string | undefined = this.formatFeatureValue(key)
          return label && value && { label, value }
        })
        .filter((group): group is IProductFeatureListItem => Boolean(group))
      return output
    },
  },
})
